<template>
    <v-container fluid class="pb-0">
        <v-layout class="visits-search-bar">
            <template>
                <div class="w-100 pr-0 pb-2 d-flex justify-content-end">
                    <v-btn v-bind="attrs" v-on="on"
                        class="mx-2 custom-bold-button custom-btn-color white--text right-btn" tile depressed
                        :disabled="pageLoading" v-on:click="createDelivery()">
                        <v-icon>mdi-plus</v-icon> Assign Driver
                    </v-btn>
                </div>
            </template>
        </v-layout>
        <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow"
            style="max-height: 90vh; position: relative">
            <ListingTable :dataLoading="pageLoading" :rowData="rowData" :columnCount="6">
                <template v-slot:thead>
                    <thead>
                        <tr>
                            <th class="simple-table-th">Driver Details</th>
                            <th class="simple-table-th">Start Date</th>
                            <th class="simple-table-th">End Date</th>
                            <th class="simple-table-th">Assign By</th>
                            <th class="simple-table-th">Assign At</th>
                            <th class="simple-table-th">Action</th>
                        </tr>
                    </thead>
                </template>
                <template v-slot:tbody>
                    <tbody class="custom-border-bottom">
                        <template v-if="!lodash.isEmpty(rowData)">
                            <tr v-for="(row, index) in rowData" :key="index" link class="customer-listing-row">
                                <td class="p-2 border-top-light-grey" width="50">
                                    <div class="engineer-listing">
                                        <p class="m-0 custom-nowrap-ellipsis text-capitalize">
                                            <b>Full name: </b> {{ engineerFullName(row) }}
                                        </p>
                                        <p class="m-0 custom-nowrap-ellipsis text-capitalize">
                                            <b>Display name: </b> {{ row.engineer_display_name }}
                                        </p>
                                        <p class="m-0 custom-nowrap-ellipsis">
                                            <b>Email: </b> {{ row.engineer_primary_email }}
                                        </p>
                                        <p class="m-0 custom-nowrap-ellipsis">
                                            <b>Phone: </b> {{ row.engineer_primary_phone }}
                                        </p>
                                    </div>
                                </td>
                                <td class="p-2 border-top-light-grey" width="250">
                                    {{ formatDate(row.start_date) }}
                                </td>
                                <td class="p-2 border-top-light-grey" width="250">
                                    {{ formatDate(row.end_date) }}
                                </td>
                                <td class="p-2 border-top-light-grey" width="50">
                                    <p class="m-0 custom-nowrap-ellipsis text-capitalize">
                                        {{ row.added_user_display_name }}</p>
                                </td>
                                <td class="p-2 border-top-light-grey" width="50">
                                    <p class="m-0 custom-nowrap-ellipsis text-capitalize">
                                        {{ formatDateTime(row.added_at) }}</p>
                                </td>
                                <td class="p-2 border-top-light-grey font-level-1" width="150">
                                    <v-btn v-on:click="deleteAction(row)" icon depressed color="red lighten-1"><v-icon
                                            medium>mdi-delete</v-icon></v-btn>
                                </td>
                            </tr>
                        </template>
                        <tr v-else-if="!pageLoading">
                            <td :colspan="6" class="py-4">
                                <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                                    <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                                    Uhh... There are no driver at the moment.
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </ListingTable>
        </perfect-scrollbar>
        <ListingFooter :dataLoading="pageLoading" :showingFrom="showingFrom" :showingTo="showingTo"
            :totalRows="totalRows" :currentPage="currentPage" :totalPages="totalPages"></ListingFooter>
        <DeleteDialog :delete-dialog="deleteAssignDriverDialog">
            <template v-slot:title>Unassigned Confirmation</template>
            <template v-slot:text>
                <h3 class="font-size-16 font-weight-500 delete-text">
                    Are you sure you want to Unassigned this driver ?
                </h3>
            </template>
            <template v-slot:action>
                <v-btn :disabled="deleteVisitLoading" class="mx-2 custom-grey-border custom-bold-button"
                    v-on:click="deleteAssignDriverDialog = false">No! Cancel</v-btn>
                <v-btn :disabled="deleteVisitLoading" :loading="deleteVisitLoading" color="red lighten-1 white--text"
                    v-on:click="unassignedDriver()" class="mx-2 custom-grey-border custom-bold-button">Yes!
                    Unassigned</v-btn>
            </template>
        </DeleteDialog>
        <Dialog :commonDialog="assignDriverDialog" :dialog-width="1000">
            <template v-slot:title><span class="ml-2">Assign Driver</span></template>
            <template v-slot:body>
                
                <v-form ref="assignForm" v-model.trim="formValid" lazy-validation
                    v-on:submit.stop.prevent="AssignDriver">
                    <table width="100%" v-if="
                        assign_drivers &&
                        assign_drivers.length > 0
                    ">
                        <tr v-for="(assign_driver, index) in assign_drivers" :key="`create-visit-attachment-${index}`">
                            <td width="30%">
                                <v-autocomplete :items="driverList" dense. filled color="cyan" item-color="cyan" solo
                                    flat :rules="[
                                        validateRules.required(
                                            assign_driver.driver,
                                            ' Drivers '
                                        ),
                                    ]" v-model.trim="assign_driver.driver" placeholder="Select Drivers"
                                    item-text="display_name" item-value="id" class="new-height" hide-details>
                                    <template v-slot:no-data>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title v-html="'No Drivers(s) Found.'"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-autocomplete>
                            </td>
                            <td width="30%">
                                <DatePicker solo flat :mandatory="true" :nullable="true" placeholder="Start Date"
                                    v-model="assign_driver.start_date" :rules="[
                                        validateRules.required(
                                            assign_driver.start_date,
                                            ' Start Date '
                                        ),
                                    ]">

                                </DatePicker>
                            </td>
                            <td width="30%">
                                <DatePicker solo flat :mandatory="true" :nullable="true"
                                    :min-date="assign_driver.start_date" placeholder="End Date"
                                    v-model="assign_driver.end_date" :rules="[
                                        validateRules.required(
                                            assign_driver.end_date,
                                            ' End Date '
                                        ),
                                    ]">

                                </DatePicker>
                            </td>
                            <td width="10%" align="center">
                                <div class="d-flex">
                                    <v-btn v-on:click="
                                        addMoreDriver()
                                        " icon class="" color="green lighten-1">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                    <v-btn v-if="assign_drivers.length > 0" v-on:click="
                                        removeDriver(index)
                                        " icon class="" color="red lighten-1">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </td>
                        </tr>
                    </table>
                </v-form>
            </template>
            <template v-slot:action>
                <v-btn class="mx-2 custom-grey-border custom-bold-button white--text" color="cyan"
                    v-on:click="AssignDriver" :disabled="assignLoading" :loading="assignLoading">
                    Assign
                </v-btn>
                <v-btn class="mx-2 custom-grey-border custom-bold-button" v-on:click="assignDriverDialog = false"
                    :disabled="assignLoading">
                    Close
                </v-btn>
            </template>
        </Dialog>
    </v-container>
</template>

<script>
import moment from "moment-timezone";
import { QUERY, DELETE } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import { getConfig } from "@/core/services/local.service";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import DeleteDialog from "@/view/pages/partials/Delete";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import Dialog from "@/view/pages/partials/Dialog";
import ValidationMixin from "@/core/plugins/validation-mixin";
import DatePicker from "@/view/components/DatePicker.vue";
import { /* SET_ERROR, */ SET_MESSAGE } from "@/core/services/store/common.module";
import ApiService from "@/core/services/api.service";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
    name: "delivery-listing-template",
    mixins: [CommonMixin, ValidationMixin],
    props: {
        typeId: {
            type: Number,
            default: null,
        },
    },
    components: {
        DeleteDialog,
        ListingFooter,
        ListingTable,
        DatePicker,
        Dialog
    },
    data() {
        return {
            driverList: [],
            totalRows: 0,
            rowsOffset: 0,
            formValid: true,
            currentPage: 1,
            totalPages: 0,
            perPage: 15,
            pageLoading: false,
            assignLoading: false,
            rowData: [],
            deleteDeliveryId: null,
            deleteAssignDriverDialog: false,
            deleteVisitLoading: false,
            deleteDeliveryBarcode: null,
            assignDriverDialog: false,
            assign_drivers: Array({
                driver: null,
                start_date: null,
                end_date: null,
            }),
        };
    },
    mounted() {
        const _this = this;

        _this.entityList = getConfig("entity");
        _this.entityObject = _this.lodash.head(_this.entityList);
        _this.$nextTick(() => {
            _this.getAssignDrivers();
            _this.getEngineerList();
        });
    },
    methods: {
        deleteAction(row) {
            this.id = row.id;
            this.deleteAssignDriverDialog = true;

        },
        closeDialog() {
            this.assignDriverDialog = false;
            this.assign_drivers = Array({
                driver: null,
                start_date: null,
                end_date: null,
            });
        },
        AssignDriver() {
            const _this = this;
            if (!_this.$refs.assignForm.validate()) {
                return false;
            }

            this.assignLoading = true;
            ApiService.post(`vehicle/${this.typeId}/assigne-driver`, { assign_drivers: this.assign_drivers })
                .then(() => {
                    this.$emit("success", true);
                    _this.$store.commit(SET_MESSAGE, [
                        { model: true, message: "Success ! Price has been updated." },
                    ]);
                    this.closeDialog();
                    this.getAssignDrivers();
                })
                .catch((error) => {
                    this.$emit("error", error);
                })
                .finally(() => {
                    this.assignLoading = false;
                });
        },
        getEngineerList() {
            const _this = this;

            _this
                .getDrivers()
                .then((engineer) => {
                    _this.driverList = engineer;
                })
                .catch((error) => {
                    _this.logError(error);
                });
        },
        getDrivers() {
            const _this = this;
            _this.engineerLoading = true;
            return new Promise((resolve, reject) => {
                try {
                    _this.$store
                        .dispatch(QUERY, {
                            url: "driver-list",
                        })
                        .then(({ data }) => {
                            resolve(data);
                        })
                        .catch((error) => {
                            _this.engineerLoading = false;
                            reject(error);
                        })
                        .finally(() => {
                            _this.engineerLoading = false;
                        });
                } catch (error) {
                    _this.logError(error);
                    _this.engineerLoading = false;
                    reject(error);
                }
            });
        },
        addMoreDriver() {
            this.assign_drivers.push({
                driver: null,
                start_date: null,
                end_date: null,
            });
        },
        removeDriver(index) {
            this.assign_drivers.splice(index, 1);
        },
        engineerFullName(data) {
            let fullName = '';
            if (data.engineer_title) {
                fullName += `${data.engineer_title} `;
            }
            else if (data.engineer_first_name) {
                fullName += `${data.engineer_first_name} `;
            }
            else if (data.engineer_last_name) {
                fullName += `${data.engineer_last_name} `;
            }
            return fullName;
        },
        createDelivery() {
            this.assignDriverDialog = true;
        },

        unassignedDriver() {
            this.deleteVisitLoading = true;
            this.$store
                .dispatch(DELETE, { url: `vehicle/${this.typeId}/unassigne-driver/${this.id}` })
                .then(() => {
                    this.id = null;
                    this.deleteAssignDriverDialog = false;
                    this.getAssignDrivers();
                })
                .catch((error) => {
                    this.logError(error);
                })
                .finally(() => {
                    this.deleteVisitLoading = false;
                });
        },
        getAssignDrivers() {
            const _this = this;

            if (_this.pageLoading) {
                return false;
            }
            _this.rowData = [];

            _this.pageLoading = true;

            let current_page = _this.currentPage;
            let per_page = _this.perPage;
            let module_type = "delivery";

            _this
                .getAssignedDriverList({ current_page, per_page, module_type })
                .then((data) => {

                    _this.rowData = data.rows;
                    _this.totalPages = Math.ceil(data.total_rows / data.per_page);
                    _this.currentPage = data.current_page;
                    _this.totalRows = data.total_rows;
                    _this.rowsOffset = data.offset;
                })
                .catch((error) => {
                    _this.logError(error);
                })
                .finally(() => {
                    _this.pageLoading = false;
                    _this.selectedRows = [];
                });
        },
        getAssignedDriverList(data) {
            const _this = this;
            return new Promise((resolve, reject) => {
                try {
                    _this.$store
                        .dispatch(QUERY, {
                            url: `vehicle/assigned-driver/${this.typeId}`,
                            data,
                        })
                        .then(({ data }) => {
                            resolve(data);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
    computed: {
        showingFrom() {
            return this.lodash.isEmpty(this.rowData) === false
                ? this.rowsOffset + 1
                : 0;
        },
        showingTo() {
            let rowData = this.lodash.map(this.rowData, function (row) {
                if (!row.header) return row;
            });

            rowData = this.lodash.without(rowData, undefined);

            return this.rowsOffset + (rowData ? rowData.length : 0);
        },
    },
    created() {
        const _this = this;
        PaginationEventBus.$on("update:pagination", (param) => {
            _this.currentPage = param;
            _this.getAssignDrivers();
        });

        PaginationEventBus.$on("update:per-page", (param) => {
            _this.perPage = param;
        });
    },
};
</script>
